import React from 'react';

export interface IProps {
    tags: string[];
}

export interface IState {}

export default class Tags extends React.Component <IProps, IState> {
    constructor(props: IProps){
        super(props);
    }

    public render(){
        if(!this.props.tags) { return null; }
        
        return <div className="product-tags-root">
                { this.props.tags.map(tag => <span key={tag} className="product-tag-label">{tag}</span>) }
               </div>;
    }
}
